import { useDispatch, useSelector } from 'react-redux';
import { updateAppState } from '../../../../actions/appstate';
import { Box, Select, MenuItem, FormControl, Switch } from '@mui/material'
import { useEffect, useState } from 'react';
import { deepCopy, getFromState } from '../../../../app/util';
import dataService from '../../../../services/data.service';
import moment from 'moment';


const SdYears = () => {
    const controls = useSelector(state => state.app.current_state.app_state.workspace_controls);
    // const { app_state, ui_state } = useSelector(
    //     (state) => state.app.current_state
    // );
    const state = useSelector(
        (state) => state
    );
    const { app_state, ui_state } = state.app.current_state

    let [sdYear, setSdYear] = useState(null);
    let comObj = { default_ly: controls.sdYear, sdYearsArr: controls.sdYearsArr, rt_years: controls.rt_years, rp_years: controls.rp_years };
    const [comState, setComState] = useState(comObj);
    let [yearsList, setYearsList] = useState([]);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        // debugger;
        controls.sdlyOn = false;
        let value = e.target.value;
        if (value) {
            setSdYear(value);
            let type = "sdyear";
            const updateTypes = [type];
            controls.sdYear = value;
            controls.sdlyOn = true;
            dispatch(
                updateAppState(
                    updateTypes, {
                    app_state: { workspace_controls: controls, data_load: true },
                    ui_state: { showspinner: true }
                }));
        } else {
            setSdYear(null);
            let type = "sdyear";
            const updateTypes = [type];
            controls.sdYear = controls.sdYearsArr[1];
            controls.sdlyOn = false;
            dispatch(
                updateAppState(
                    updateTypes, {
                    app_state: { workspace_controls: controls, data_load: true },
                    ui_state: { showspinner: true }
                }));
        }

    }

    useEffect(() => {
        if(controls.sdlyOn){
            setSdYear(controls.sdYear);
        }
        let propertyDetails = deepCopy(dataService.getSeriesById("GetPropData").data);
        if (propertyDetails && propertyDetails.years) {

            let sdYearsArr = [null].concat(propertyDetails.years);
            let rt_years = propertyDetails["rt-years"];
            let rp_years = propertyDetails["rp-years"];
            let default_ly = propertyDetails.default_ly;

            let lyYears = moment(app_state.as_of_date).subtract(1, 'years').format('YYYY');
            if(!controls.sdlyOn){
                setSdYear(sdYearsArr[0]);
            }            

            // controls.sdYear = lyYears; //(default_ly) ? default_ly : controls.sdYear;
            controls.sdYearsArr = (sdYearsArr.length > 0) ? sdYearsArr : controls.sdYearsArr;

            controls.rt_years = (rt_years.length > 0) ? rt_years : controls.sdYear;
            controls.rp_years = (rp_years.length > 0) ? rp_years : controls.sdYear;

            // const updateTypes = [type];
            //controls.sdlyOn = false;
            
            // debugger;
            //If active tiles has been changed
            if (ui_state.active_tiles.includes('market')) {
                let marketSdYears = [];
                let allYears = [];
                const selected_market = app_state.selected_market;
                // let market_settings = getFromState('system_settings>market_settings', state, app_state.property_id);

                if (ui_state.active_tiles.length === 1) {
                    //if market yeas is not available then use properties sdyears
                    marketSdYears = selected_market.year ? selected_market.year : controls.sdYearsArr;
                    sdYearsArr = marketSdYears[0] ? [null].concat(marketSdYears) : marketSdYears ;
                } else {
                    selected_market.year = selected_market.year ? selected_market.year : [];                  
                    allYears = [...controls.sdYearsArr, ...selected_market.year];
                    allYears.forEach((v)=> { if (!marketSdYears.includes(v)) marketSdYears.push(v) });
                    sdYearsArr = marketSdYears;
                    controls.sdYear = marketSdYears[1];
                }
                // debugger;
                if (controls.sdYear && allYears.length && !allYears.includes(controls.sdYear)) {
                    // marketSdYears.sort().reverse();
                    controls.sdYear = marketSdYears[0];
                }
            }
            // debugger;
            yearsList = sdYearsArr;
            controls.sdYearsArr = sdYearsArr;
            setYearsList(sdYearsArr);

            dispatch(updateAppState("sdlyToggle", {
                app_state: {
                    ...app_state,
                    workspace_controls: { ...controls },
                    // data_load: true,
                    // kpi_load: true
                },
                ui_state: {
                    ...ui_state,
                    // showspinner: true 
                }
            }));

        } else {
            if (!controls.sdlyOn) {
                //controls.sdYear = null;
                //sdYear = null;
                setSdYear(null);
            }
            dispatch(updateAppState("sdlyToggle", {
                app_state: {
                    ...app_state,
                    workspace_controls: { ...controls },
                    // data_load: true,
                    // kpi_load: true
                },
                ui_state: {
                    ...ui_state,
                    // showspinner: true 
                }
            }));
        }


    }, [app_state.property_id, ui_state.active_tiles.join('_')]);

    let segmentType = app_state.workspace_controls.segmentType;
    if (!ui_state.active_tiles.includes('market')) {

    }
    if (ui_state.active_tiles[0] === "otb_v2_multi_segment" && segmentType === "rate_plan") {
        yearsList = (controls.rp_years.length > 1) ? controls.rp_years : controls.rp_years.splice(0,0,null);
    } else if (ui_state.active_tiles[0] === "otb_v2_multi_segment" && segmentType === "room_type") {
        yearsList = (controls.rt_years.length > 1) ? controls.rt_years : controls.rt_years.splice(0,0,null);
    } else {
        yearsList = controls.sdYearsArr;
    }
    return (
        <>
            <Box id="sdyearBox" sx={{ height: 1 / 2 }}>
                <Box sx={{ display: 'block', fontSize: '75%', fontWeight: 'bold' }}>Compare With</Box>
                <FormControl size="small" sx={{ minWidth: "100%", borderRadius: "16px" }}>
                    <Select displayEmpty className='tabular-data-filter' value={sdYear} sx={{ height: "27px", minWidth: "70px", mt: "5px" }}
                        onChange={handleChange}>
                        {/* <MenuItem value="" disabled className='tabular-data-filter'>Select Year </MenuItem> */}
                        {yearsList && yearsList.map((items, index) => {
                            if (!items) {
                                return (<MenuItem value={items} className='tabular-data-filter'> --- </MenuItem>)
                            }
                            if (items <= moment(app_state.as_of_date).subtract(1, 'years').format('YYYY')) {
                                return (<MenuItem value={items} className='tabular-data-filter'> {items} </MenuItem>)
                            }
                        })}

                    </Select>
                </FormControl>
            </Box>

        </>
    )
}

export default SdYears